var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWhyenhanced = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 101,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#why_enhanced_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#why_enhanced_svg__b)",
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#why_enhanced_svg__c)",
  fillRule: "evenodd",
  d: "M35.422 84.346c4.635.319 12.02.653 22.578.653s17.943-.334 22.578-.653c4.602-.316 8.345-4.09 8.78-9.272.335-3.97.642-9.749.642-17.575s-.307-13.605-.64-17.573c-.437-5.184-4.18-8.957-8.782-9.273C75.943 30.334 68.558 30 58 30s-17.943.334-22.578.653c-4.602.316-8.345 4.09-8.78 9.272-.335 3.97-.642 9.749-.642 17.574s.307 13.606.64 17.574c.437 5.184 4.18 8.957 8.782 9.273",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#9B004D",
  fillRule: "evenodd",
  d: "M64.346 76.606a.714.714 0 0 0-.707-.625H52.215a.714.714 0 0 0-.708.625l-1.116 8.922a2.14 2.14 0 0 1-2.126 1.876h-4.07c-1.488 0-2.809.953-3.28 2.365a2.543 2.543 0 0 0 2.414 3.347h29.194c1.736 0 2.962-1.7 2.414-3.347a3.46 3.46 0 0 0-3.28-2.365h-4.07c-1.08 0-1.99-.804-2.125-1.876z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#why_enhanced_svg__d)",
  fillRule: "evenodd",
  d: "M35.253 80.384c4.654.29 12.07.594 22.669.594s18.015-.304 22.669-.594c4.62-.287 8.38-3.716 8.816-8.425.336-3.607.644-8.859.644-15.97s-.308-12.363-.642-15.969c-.439-4.71-4.197-8.14-8.818-8.426-4.654-.29-12.07-.594-22.669-.594s-18.015.304-22.669.594c-4.62.287-8.38 3.715-8.816 8.425-.336 3.608-.644 8.859-.644 15.97s.308 12.363.643 15.969c.438 4.71 4.196 8.139 8.817 8.426",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M56.495 65.27c-1.65 0-2.68-1.784-1.855-3.212a2.14 2.14 0 0 1 1.855-1.071H73.63c1.65 0 2.68 1.785 1.855 3.213a2.14 2.14 0 0 1-1.855 1.07z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M54.352 53.133c0-1.183.959-2.142 2.142-2.142H79.34c1.649 0 2.68 1.785 1.855 3.213a2.14 2.14 0 0 1-1.855 1.07H56.494a2.14 2.14 0 0 1-2.142-2.141M54.352 43.137c0-1.183.959-2.142 2.142-2.142H79.34c1.649 0 2.68 1.785 1.855 3.213a2.14 2.14 0 0 1-1.855 1.071H56.494a2.14 2.14 0 0 1-2.142-2.142"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M35.077 40.995c-1.65 0-2.68 1.785-1.855 3.213a2.14 2.14 0 0 0 1.855 1.071h4.284c1.649 0 2.68-1.785 1.855-3.213a2.14 2.14 0 0 0-1.855-1.07zm0 9.996c-1.65 0-2.68 1.785-1.855 3.213a2.14 2.14 0 0 0 1.855 1.07h4.284c1.649 0 2.68-1.784 1.855-3.212a2.14 2.14 0 0 0-1.855-1.071z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#why_enhanced_svg__e)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.15,
  d: "M33.048 48.883c.559 0 1.058.348 1.246.869l1.342 3.718q.72.179 1.242.365.572.203 1.482.627l3.124-1.653a1.33 1.33 0 0 1 1.58.249l2.748 2.84c.365.378.467.931.262 1.414l-1.465 3.433q.364.669.585 1.147.24.52.593 1.444l3.414 1.463c.513.219.83.732.797 1.281l-.251 3.942a1.31 1.31 0 0 1-.874 1.15l-3.234 1.15q-.139.668-.293 1.15-.248.75-.566 1.471l1.625 3.591a1.3 1.3 0 0 1-.32 1.507L42.997 82.8a1.335 1.335 0 0 1-1.512.182L38.3 81.295a14 14 0 0 1-1.54.697l-1.39.52-1.235 3.42a1.32 1.32 0 0 1-1.216.87l-3.61.08a1.32 1.32 0 0 1-1.271-.848l-1.455-3.852a28 28 0 0 1-1.475-.55q-.596-.26-1.174-.557l-3.61 1.542a1.33 1.33 0 0 1-1.434-.252l-2.671-2.506a1.3 1.3 0 0 1-.295-1.488l1.552-3.382q-.31-.6-.573-1.224a27 27 0 0 1-.57-1.54l-3.401-1.036A1.31 1.31 0 0 1 12 69.891l.133-3.65a1.31 1.31 0 0 1 .745-1.128l3.568-1.714q.247-.907.437-1.421.269-.69.596-1.353l-1.546-3.268a1.3 1.3 0 0 1 .285-1.5l2.667-2.52a1.33 1.33 0 0 1 1.425-.262l3.606 1.49c.4-.267.76-.481 1.087-.654.39-.208.91-.424 1.565-.658l1.254-3.498a1.32 1.32 0 0 1 1.247-.872zM31.046 62.22c-3.168 0-5.734 2.537-5.734 5.668s2.566 5.67 5.734 5.67c3.165 0 5.732-2.539 5.732-5.67s-2.565-5.668-5.732-5.668"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#why_enhanced_svg__f)",
  strokeWidth: 0.2,
  d: "m35.56 53.554-.018-.05-1.342-3.718a1.22 1.22 0 0 0-1.152-.803H29.07c-.252 0-.498.077-.704.221l-.057-.082.057.082a1.22 1.22 0 0 0-.449.585l-1.254 3.498-.015.045-.045.015q-.98.348-1.552.652c-.324.171-.682.384-1.078.648l-.045.03-.05-.02-3.605-1.49a1.23 1.23 0 0 0-1.318.243l-2.668 2.519a1.2 1.2 0 0 0-.263 1.385l1.546 3.268.021.044-.021.043q-.326.66-.593 1.345c-.126.34-.27.807-.434 1.411l-.012.044-.041.02-3.568 1.714a1.2 1.2 0 0 0-.49.425l-.083-.055.083.056c-.12.183-.19.396-.198.616zm0 0 .052.013m-.052-.013.052.013m0 0c.478.12.887.238 1.233.362m-1.233-.362 1.233.362m0 0q.566.2 1.473.623l.045.021m-1.518-.644 1.518.644m0 0 .044-.023m-.044.023.044-.023m0 0 3.124-1.653m-3.124 1.653 3.124-1.653m0 0a1.234 1.234 0 0 1 1.462.23l2.747 2.84zm2.967 7.853.02-.044 1.464-3.434c.19-.445.095-.955-.242-1.304zm0 0 .024.043m-.024-.043.024.043m0 0q.362.667.582 1.142c.158.344.355.82.59 1.437l.015.04m-1.187-2.62 1.187 2.62m0 0 .039.016m-.04-.016.04.016m0 0 3.414 1.463m-3.414-1.463 3.414 1.463m0 0c.475.203.767.676.736 1.183m-.736-1.183.736 1.183m-1.059 5.004a1.21 1.21 0 0 0 .808-1.062zm0 0-3.233 1.15-.053.018m3.286-1.168-3.286 1.168m4.345-6.172-.251 3.942-.446-5.217c.513.219.83.732.797 1.281zm-4.345 6.172-.012.055m.012-.055-.012.055m0 0a12 12 0 0 1-.29 1.14q-.247.744-.562 1.462l-.018.04m.87-2.642-.87 2.643m0 0 .018.04m-.018-.04.018.04m0 0 1.625 3.592m-1.625-3.591 1.625 3.59m0 0a1.2 1.2 0 0 1-.295 1.391m.295-1.39-.295 1.39m0 0-3.09 2.76zm-7.72 1.216.047.025 3.185 1.687a1.24 1.24 0 0 0 1.399-.169zm0 0-.046.025m.047-.025-.047.025m0 0q-.743.392-1.528.692l-1.39.52-.044.017m2.962-1.23-2.962 1.23m0 0-.015.043m.015-.043-.015.043m0 0-1.235 3.42a1.22 1.22 0 0 1-1.124.802m2.359-4.222-2.36 4.222m0 0-3.61.082m3.61-.082-3.61.082m0 0a1.23 1.23 0 0 1-.712-.206m.712.206-.712-.206m-1.934-4.474.016.044 1.455 3.85zm0 0-.045-.015m.045.015-.045-.015m0 0a28 28 0 0 1-1.468-.549 19 19 0 0 1-1.167-.553l-.042-.022m2.677 1.124-2.677-1.124m0 0-.043.019m.043-.019-.043.019m0 0-3.61 1.542a1.23 1.23 0 0 1-1.327-.233l-2.671-2.506m7.608 1.197-7.608-1.198m0 0a1.2 1.2 0 0 1-.272-1.373l1.552-3.381.02-.044m-1.3 4.799 1.3-4.8m0 0-.022-.043m.022.044-.022-.044m0 0a18 18 0 0 1-.57-1.216 27 27 0 0 1-.568-1.534l-.016-.05m1.154 2.8-1.154-2.8m0 0-.05-.014m.05.015-.05-.015m0 0-3.4-1.036m3.4 1.036-3.4-1.036m0 0a1.2 1.2 0 0 1-.634-.453m.634.453-.634-.453m16.267 15.937a1.22 1.22 0 0 1-.462-.579zM12.327 70.64a1.2 1.2 0 0 1-.226-.745m.226.745-.226-.745m0 0Zm18.945-7.776c-3.222 0-5.834 2.58-5.834 5.768s2.612 5.77 5.834 5.77c3.22 0 5.832-2.583 5.832-5.77 0-3.188-2.611-5.768-5.832-5.768Z"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#why_enhanced_svg__g)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M31.97 58.883c.265 0 .502.165.59.412l.636 1.76q.341.086.589.174.27.097.702.297l1.479-.783a.63.63 0 0 1 .749.118l1.301 1.345c.173.18.222.441.124.67l-.694 1.626q.174.316.278.544.113.246.28.683l1.618.694a.62.62 0 0 1 .377.606l-.119 1.868a.62.62 0 0 1-.414.544l-1.532.545q-.066.316-.138.545a8 8 0 0 1-.268.697l.769 1.7a.615.615 0 0 1-.151.714l-1.464 1.307a.63.63 0 0 1-.716.086l-1.508-.799q-.354.188-.73.33l-.658.247-.585 1.62a.63.63 0 0 1-.576.411l-1.71.04a.63.63 0 0 1-.602-.403l-.69-1.825q-.353-.12-.698-.26a9 9 0 0 1-.556-.264l-1.71.73a.63.63 0 0 1-.68-.12l-1.265-1.186a.615.615 0 0 1-.14-.705l.736-1.602a9 9 0 0 1-.272-.58q-.146-.36-.27-.73l-1.61-.49a.62.62 0 0 1-.442-.614l.063-1.73a.62.62 0 0 1 .353-.534l1.69-.812q.118-.43.207-.673.128-.327.283-.64l-.733-1.549a.615.615 0 0 1 .135-.71l1.264-1.194a.63.63 0 0 1 .675-.124l1.708.705q.283-.187.515-.31.275-.145.741-.31l.594-1.658a.63.63 0 0 1 .59-.413zm-.948 6.317c-1.5 0-2.716 1.202-2.716 2.685s1.215 2.686 2.716 2.686c1.499 0 2.715-1.203 2.715-2.686S32.522 65.2 31.022 65.2"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#why_enhanced_svg__h)",
  strokeWidth: 0.2,
  d: "M34.487 61.526a9 9 0 0 0-.703-.297 6 6 0 0 0-.588-.173zm0 0 1.479-.783m-1.48.783 1.48-.783m0 0a.63.63 0 0 1 .749.118m-.749-.118 1.48 3.759m.694-1.626-.694 1.626m.694-1.626a.62.62 0 0 0-.124-.67m.124.67-.092-.04m.092.04-.092-.04m-.602 1.666q.174.316.278.544m-.277-.544.277.544m.292-2.84-1.301-1.345m1.301 1.345-.072.07m.072-.07-.072.07m-1.23-1.415-.07.07m.07-.07-.071.07a.53.53 0 0 0-.63-.1l-1.48.783-.044.023-.045-.02a9 9 0 0 0-.693-.294 6 6 0 0 0-.58-.17l-.051-.013-.018-.05-.635-1.761.094-.034-.094.033a.53.53 0 0 0-.497-.345h-1.884a.53.53 0 0 0-.497.347l-.594 1.657-.015.045-.045.016q-.462.164-.728.305-.227.119-.507.304l-.044.03-.05-.02-1.707-.706a.53.53 0 0 0-.569.105l-1.263 1.193a.515.515 0 0 0-.113.596l.732 1.548.02.043-.02.044a8 8 0 0 0-.28.632 8 8 0 0 0-.203.663l-.012.045-.041.02-1.69.811a.52.52 0 0 0-.297.448l-.063 1.729a.52.52 0 0 0 .37.516l1.611.49.05.015.016.049q.123.366.268.723.123.291.268.572l.022.044-.02.044-.735 1.602a.515.515 0 0 0 .117.59l1.265 1.187a.53.53 0 0 0 .572.1l10.74-13.84m0 0 1.3 1.346m-1.3-1.346.989 4.158m2.266 1.935-.119 1.867a.52.52 0 0 1-.347.457l-1.532.544-.053.02-.012.054a6 6 0 0 1-.135.535 8 8 0 0 1-.265.687l-.018.041.018.04.77 1.702a.515.515 0 0 1-.127.597l-1.463 1.307a.53.53 0 0 1-.603.073l-1.508-.8-.047-.024-.047.025a6 6 0 0 1-.718.325l-.658.246-.043.017-.016.043-.585 1.62a.525.525 0 0 1-.484.345l-1.71.04a.53.53 0 0 1-.507-.339l-.689-1.824-.017-.044-.044-.015a13 13 0 0 1-.692-.259 9 9 0 0 1-.55-.26l-.04-.022-.044.019-1.71.73 14.095-7.74zm0 0a.52.52 0 0 0-.316-.508l-1.618-.694-.039-.016-.015-.04a12 12 0 0 0-.278-.677m2.266 1.935-2.266-1.935m0 0 .09-.042m-.09.041.09-.041m-.09.041a10 10 0 0 0-.274-.537l-.023-.043.019-.044.693-1.626m0 0a.52.52 0 0 0-.104-.562M31.022 65.1c-1.555 0-2.816 1.246-2.816 2.785s1.261 2.786 2.816 2.786c1.553 0 2.815-1.247 2.815-2.786 0-1.54-1.261-2.785-2.815-2.785Z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "why_enhanced_svg__c",
  x1: 45.035,
  x2: 91.494,
  y1: 33.405,
  y2: 75.453,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F2A849"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF0084"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "why_enhanced_svg__d",
  x1: 25.793,
  x2: 111.032,
  y1: 56.241,
  y2: 58.547,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C830E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE4A25"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "why_enhanced_svg__f",
  x1: 12,
  x2: 62.422,
  y1: 68.075,
  y2: 69.136,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C830E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE4A25"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "why_enhanced_svg__h",
  x1: 22,
  x2: 45.884,
  y1: 67.974,
  y2: 68.477,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C830E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE4A25"
})), /*#__PURE__*/React.createElement("filter", {
  id: "why_enhanced_svg__b",
  width: 88,
  height: 79,
  x: 14,
  y: 18,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_20508_13656",
  stdDeviation: 6
})), /*#__PURE__*/React.createElement("filter", {
  id: "why_enhanced_svg__e",
  width: 46,
  height: 46,
  x: 8,
  y: 44.883,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_20508_13656"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_20508_13656",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.988235 0 0 0 0 0.0941176 0 0 0 0 0.52549 0 0 0 0.36 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect2_innerShadow_20508_13656"
})), /*#__PURE__*/React.createElement("filter", {
  id: "why_enhanced_svg__g",
  width: 26,
  height: 26,
  x: 18,
  y: 54.883,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_20508_13656"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_20508_13656",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.988235 0 0 0 0 0.0941176 0 0 0 0 0.52549 0 0 0 0.36 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect2_innerShadow_20508_13656"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "why_enhanced_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 100,
  height: 100,
  y: 0.883,
  fill: "#fff",
  rx: 20
})))));
export { SvgWhyenhanced as ReactComponent };
export default __webpack_public_path__ + "static/media/why.enhanced.601577aa.svg";